import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, OnInit , OnDestroy} from '@angular/core';
import { Store } from '@ngrx/store';
import { QueryStates } from '../query.reducer';

@Component({
  selector: 'app-queryset',
  templateUrl: './queryset.component.html',
  styleUrls: ['./queryset.component.scss']
})
export class QuerysetComponent implements OnInit {

  _panels = [{panel: 'principal'}];
  showSecPanel = true;

  private subscriptionChangeUrlQuery: Subscription;

  constructor(    private router: Router , private store: Store<QueryStates>) {
   }

  ngOnInit() {
        // observa cambio de valores en la URL
        this.subscriptionChangeUrlQuery = 
        this.router.events.pipe(
          filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
          this._panels = [{panel: 'principal'}];
          this.showSecPanel = false;
        });
  }

  onSplitPanel() {
    if (this.showSecPanel) {
      this. _panels.push({panel: 'Secundario'});
    } else {
      this. _panels.splice(1, 1);
    }
  }

  ngOnDestroy() {
    // se cancela subscripcion al evento de cambio de url
    if (this.subscriptionChangeUrlQuery) {
      this.subscriptionChangeUrlQuery.unsubscribe();
    }
  }


  //////// 
  splitProcess(statePage) {
    this.showSecPanel = statePage.split; // !this.showSecPanel;
    this.onSplitPanel();
  }

}
